import React from 'react';

import { Button } from 'components';

import styles from './DefaultModalContent.module.scss';

interface DefaultModalContent {
  title: string;
  subtext: string;
  cancelButtonText: string;
  onCancel: any;
  actionButtonText: string;
  actionButtonType?: string;
  onAction: any;
}

export const DefaultModalContent: React.FC<DefaultModalContent> = ({
  title,
  subtext,
  cancelButtonText,
  onCancel,
  actionButtonText,
  actionButtonType = 'Default',
  onAction,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>{title}</h3>
      </div>
      <div className={styles.content}>
        {/* 
          This dangerouslySetInnerHTML is here because we may need to render
          html tags inside the subtext 
        */}
        <div
          dangerouslySetInnerHTML={{
            __html: subtext,
          }}
        />
      </div>
      <div className={styles.footer}>
        <Button type="Cancel" onClick={onCancel}>
          {cancelButtonText}
        </Button>
        <Button type={actionButtonType} onClick={onAction}>
          {actionButtonText}
        </Button>
      </div>
    </div>
  );
};
